import { AnimatePresence, motion } from 'framer-motion';
import { useMenuStore } from '../../../stores';
import { MenuMobileStatusBar } from './MenuMobileStatusBar';
import { MenuMobileNavBar } from './MenuMobileNavBar';
import { MenuMobilePanel } from './MenuMobilePanel';
import { ErrorBoundary } from 'react-error-boundary';

export function MenuMobile() {
  const isMenuOpen = useMenuStore.use.isMenuOpen();

  return (
    <AnimatePresence key="menu-mobile">
      {isMenuOpen && (
        <motion.div
          className="tlw-fixed tlw-inset-0 tlw-grid tlw-grid-rows-[auto_auto_1fr] tlw-bg-white lg:tlw-hidden"
          initial={{ x: '-100%' }}
          animate={{ x: 0 }}
          exit={{ x: '-100%' }}
          transition={{ duration: 0.3 }}
        >
          {/* 狀態欄 */}
          <ErrorBoundary fallback={<div>MenuMobileStatusBar</div>}>
            <MenuMobileStatusBar />
          </ErrorBoundary>

          {/* 菜單導航 */}
          <ErrorBoundary fallback={<div>MenuMobileNavBar</div>}>
            <MenuMobileNavBar />
          </ErrorBoundary>

          {/* 菜單面板 */}
          <ErrorBoundary fallback={<div>MenuMobilePanel</div>}>
            <MenuMobilePanel />
          </ErrorBoundary>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
